// extracted by mini-css-extract-plugin
module.exports = {"ComponentHolder":"CommentList_ComponentHolder__3eo23","DateOrder":"CommentList_DateOrder__hukJa"};